var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('h1',{staticClass:"prenom-profil"},[_vm._v("\n   "+_vm._s(_vm.user.first_name)+"\n ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }